import { PlansPlanMode } from '../api/types'
import { LumpsumRebalanceBody } from './body/rebalance/LumpsumRebalanceBody'
import { RebalancePlansListErrorState } from './body/rebalance/RebalancePlansListErrorState'
import { LumpsumPlansFooter } from './footer/LumpsumPlansFooter'
import { PlansListChrome } from './header/common/PlansListChrome'
import { LumpsumPlansActionFilters } from './header/common/LumpsumPlansActionFilters'
import {
  LumpsumRebalanceHeader,
  resolveRebalanceHeaderAppearance
} from './header/rebalance/LumpsumRebalanceHeader'
import {
  isListPlansFetchFailed,
  isListPlansLoading,
  useLumpsumPlansContext
} from './LumpsumPlansProvider'
import { PlansCategoryListSkeleton } from './lumpsum-ui-components/PlansCategoryListSkeleton'
import { RebalanceTimerPanel } from './timer/rebalance/RebalanceTimerPanel'
import { isRebalancePlanAvailable } from './timer/shared/planStatus'

/**
 * Rebalance tab content.
 * - Fetch failed → error (must beat timer: missing isPlanAvailable looks like not available)
 * - Not available → timer shell (full panel); rebalance has no planStatus from BE
 * - Available → header + filters + body + footer (lock handled in body)
 */
export function RebalancePageContent() {
  const { rebalancePlansData, rebalancePlansQuery } = useLumpsumPlansContext()
  const chromeBackground = resolveRebalanceHeaderAppearance(
    rebalancePlansData?.riskProfile
  ).chromeBackground

  if (isListPlansLoading(PlansPlanMode.REBALANCE, rebalancePlansQuery)) {
    return (
      <>
        <PlansListChrome background={chromeBackground}>
          <LumpsumRebalanceHeader />
        </PlansListChrome>
        <PlansCategoryListSkeleton />
      </>
    )
  }

  if (isListPlansFetchFailed(PlansPlanMode.REBALANCE, rebalancePlansQuery)) {
    return <RebalancePlansListErrorState onRetry={rebalancePlansQuery.refetch} />
  }

  if (!isRebalancePlanAvailable(rebalancePlansData?.isPlanAvailable)) {
    return (
      <RebalanceTimerPanel
        timeToPlanDrop={rebalancePlansData?.timeToPlanDrop}
        isSubscriptionEligible={rebalancePlansData?.isPlanSubscriptionEligible === true}
      />
    )
  }

  return (
    <>
      <PlansListChrome background={chromeBackground}>
        <LumpsumRebalanceHeader />
        <LumpsumPlansActionFilters />
      </PlansListChrome>
      <LumpsumRebalanceBody />
      <LumpsumPlansFooter />
    </>
  )
}
